import { Config } from '../config';

export const UserService = {
  /**
 * [LOGIN]
 * @param {object} data
 * @param {string} data.login
 * @param {string} data.password
 * @param {string} data.authenticatorCode
 */
  Login(data) {
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    };

    return UserService.Common.Fetch(Config.service.user.login, requestOptions);
  },
  /**
* [PRELOGIN]
* @param {object} data
* @param {string} data.login
* @param {string} data.password
*/
  PreLogin(data) {
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    };

    return UserService.Common.Fetch(Config.service.user.preLogin, requestOptions);
  },
  /**
    * [LOGOUT]
    */
  Logout() {
    localStorage.removeItem('user');
  },
  /**
     * [RECOVERPASSWORD]
     * @param {object} data
     * @param {string} data.email
     */
  ResetPassword(data) {
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    };

    return UserService.Common.Fetch(Config.service.user.recoverPassword, requestOptions);
  },
  /**
    * [AUTHENTICATED]
    */
  Authenticated() {
    const requestOptions = {
      method: 'POST',
      headers: Config.utilities.authorizedHeader(),
    };

    Config.utilities.loadingAuth();

    return fetch(Config.service.user.authenticated, requestOptions)
      .then(response => {
        Config.utilities.loadingAuth();
        if (response.ok) {
          return true;
        }
        return false;
      }).catch(() => {
        Config.utilities.loadingAuth();
        return false;
      });
  },
  /**
    * [XSRF]
    */
  Xsrf() {
    const requestOptions = {
      method: 'Get',
      headers: Config.utilities.authorizedHeader(),
    };

    return UserService.Common.Fetch(Config.service.user.xsrf, requestOptions);
  },
  /**
    * [DASHBOARD]
    */
  Dashboard() {
    const requestOptions = {
      method: 'Get',
      headers: Config.utilities.authorizedHeader(),
    };

    return UserService.Common.Fetch(Config.service.user.dashboard, requestOptions);
  },
  /**
    * [SETTINGS]
    */
  Settings() {
    const requestOptions = {
      method: 'Get',
      headers: Config.utilities.authorizedHeader(),
    };

    return UserService.Common.Fetch(Config.service.user.settings, requestOptions);
  },
  /**
    * [SAVE_SETTINGS]
    */
  SaveSettings(formData) {
    const requestOptions = {
      method: 'Post',
      headers: Config.utilities.authorizedHeader(),
      body: JSON.stringify(formData),
    };

    return UserService.Common.Fetch(Config.service.user.saveSettings, requestOptions);
  },
  /**
    * [PROFILE]
    */
  Profile() {
    const requestOptions = {
      method: 'Get',
      headers: Config.utilities.authorizedHeader(),
    };

    return UserService.Common.Fetch(Config.service.user.profile, requestOptions);
  },
  /**
    * [SAVE_PROFILE]
    */
  SaveProfile(formData) {
    const requestOptions = {
      method: 'Post',
      headers: Config.utilities.authorizedHeader(),
      body: JSON.stringify(formData),
    };

    return UserService.Common.Fetch(Config.service.user.saveProfile, requestOptions);
  },
  /**
 * [USERLIST]
 */
  UserList() {
    const requestOptions = {
      method: 'Get',
      headers: Config.utilities.authorizedHeader(),
    };
    return UserService.Common.Fetch(Config.service.common.user.list, requestOptions);
  },

  /**
    * [USERDETAIL]
    */
  Detail(id) {
    const requestOptions = {
      method: 'POST',
      headers: Config.utilities.authorizedHeader(),
      body: JSON.stringify(id),
    };

    return UserService.Common.Fetch(Config.service.common.user.detail, requestOptions);
  },
  /**
   * [USERSAVE]
   */
  Save(data) {
    const requestOptions = {
      method: 'POST',
      headers: Config.utilities.authorizedHeader(),
      body: JSON.stringify(data),
    };

    return UserService.Common.Fetch(Config.service.common.user.editsave, requestOptions);
  },
  /**
   * [USERDELETE]
   */
  Delete(id) {
    const requestOptions = {
      method: 'POST',
      headers: Config.utilities.authorizedHeader(),
      body: JSON.stringify(id),
    };

    return UserService.Common.Fetch(Config.service.common.user.delete, requestOptions);
  },
  /**
    * [GET_CURRENCIES]
    */
  GetCurrencyList() {
    const requestOptions = {
      method: 'Get',
      headers: Config.utilities.authorizedHeader(),
    };
    return UserService.Common.Fetch(Config.service.common.currency.getList, requestOptions);
  },
  /**
    * [UPDATE_CURRENCY]
    */
  UpdateCurrency(data) {
    const requestOptions = {
      method: 'POST',
      headers: Config.utilities.authorizedHeader(),
      body: JSON.stringify(data),
    };

    return UserService.Common.Fetch(Config.service.common.currency.update, requestOptions);
  },
  /**
     * [COMMON]
     * @function Fetch
     */
  Common: {
    Fetch(url, requestOptions) {
      return fetch(url, requestOptions)
        .then(response => {
          if (response.ok) {
            return response.json();
          }
          if (response.status === 401) {
            UserService.Logout();
            window.location.reload();
          } else {
            throw new Error();
          }
          return false;
        })
        .then(json => json)
        .catch(() => false);
    },
  },
};
